import { SITUACAO_VOTO } from '@/dominio/SituacaoVoto';
import { makeObservable, observable } from 'mobx';
import IconeVotoRevogado from '../IconeVotoRevogado';
import { Filtro } from './Filtro';

export default class FiltroVotacaoComVotoRevogado extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Votação com pelo menos 1 voto revogado';
    }

    getIconeFiltroRapido() {
        return (
            <IconeVotoRevogado
                removerTooltip
                removerEstiloPadrao
            />
        );
    }

    filtroRapido = { valor: true };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return (
            registro.votos && registro.votos.findIndex((voto) => voto.situacaoVoto === SITUACAO_VOTO.REVOGADO.id) !== -1
        );
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
